export type CheckoutErrorType = {
  url: string;
  err: any;
  payload: any;
};

export enum ErrorType {
  CHECKOUT_ERROR = "CHECKOUT_ERROR",
  PIXEL_ERROR = "PIXEL_ERROR",
  CART_ERROR = "CART_ERROR",
  CHECKOUT_TIME_LIMIT_EXCEEDED = "CHECKOUT_TIME_LIMIT_EXCEEDED",
  TURNSTILE_ERROR = "TURNSTILE_ERROR",
  SDK_FAILURE = "SDK_FAILURE",
  PAYMENT_INTITATE_TIMEOUT = "PAYMENT_INTITATE_TIMEOUT",
  PAYMENT_INITIATE_FAILED = "PAYMENT_INITIATE_FAILED",
  ORDER_PLACEMENT_FAILED = "ORDER_PLACEMENT_FAILED",
  BUREAU_ERROR = "BUREAU_ERROR",
}
